import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/brand.css';

const PrivacyPolicy = () => (
  <main className="policy-page">
    <Container>
      <section className="policy-card">
        <p className="policy-kicker">Access70 LMS</p>
        <h1>Privacy Policy</h1>
        <p className="policy-updated">Last updated: 19 June 2026</p>

        <h2>1. Privacy Commitment</h2>
        <p>
          NPI Governance Solutions handles personal information responsibly and uses it only for authorised programme, learning,
          administration, communication, reporting, security, and compliance purposes.
        </p>

        <h2>2. Access Controls</h2>
        <p>
          Personal information is protected through authenticated access, role-based permissions, storage rules, and administrative
          controls. Users should only access information needed for their assigned responsibilities.
        </p>

        <h2>3. Sharing of Information</h2>
        <p>
          Information may be shared with authorised NPI staff, facilitators, assessors, QA users, programme partners, funders,
          compliance bodies, or service providers where this is necessary for programme delivery or reporting.
        </p>

        <h2>4. Security</h2>
        <p>
          The platform uses technical and organisational controls to reduce unauthorised access, accidental loss, misuse, or disclosure.
          No online system can guarantee absolute security, but access and storage controls are maintained as part of normal operation.
        </p>

        <h2>5. User Rights</h2>
        <p>
          Users may request correction of inaccurate information or raise privacy questions through the programme administrator or NPI
          support channel. Requests will be handled according to applicable South African data protection requirements.
        </p>

        <h2>6. Contact</h2>
        <p>
          Privacy and data handling queries should be directed to the relevant programme administrator or NPI Governance Solutions
          support representative.
        </p>
      </section>
    </Container>
  </main>
);

export default PrivacyPolicy;
